const siteCategoriesModule = {
  state: {
    items: null,
    pagination: null
  },
  mutations: {
    setSiteCategories(state, data) {
      state.items = data
    },
    setSiteCategoriesPagination(state, data) {
      state.pagination = data
    }
  },
  getters: {
    getSiteCategories: (state) => {
      return state.items
    },
    getSiteCategoriesPagination: (state) => {
      return state.pagination
    }
  }
}

export default siteCategoriesModule 


// WEBPACK FOOTER //
// ./src/store/modules/site_categories.js